/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PurchaseCaseParcelCreateDto } from './purchaseCaseParcelCreateDto.model';


export interface PurchaseCaseCreateDto { 
    approvalAcreage?: number;
    approvalDate?: string;
    approvalNumber?: string;
    approvalPrice?: number;
    bankAccountNumber?: string;
    cadastreEntryDate?: string;
    concernedId?: number;
    entryProposalDate?: string;
    id?: number;
    note?: string;
    owners?: Array<number>;
    priceBank?: number;
    priceCash?: number;
    priceDeposit?: number;
    proceedingNumber?: string;
    purchaseCaseParcelCreateDtos?: Array<PurchaseCaseParcelCreateDto>;
    secondaryCosts?: number;
    signatureDate?: string;
    template?: number;
}

